export const getAuthHeader = () => {
    const token = localStorage.getItem("token");
   
    if (!token) {
      console.warn("No authentication token found in localStorage");
      return {};
    }
    
    return { Authorization: `Bearer ${token}` };
  };

// Utility function to validate MongoDB ObjectId format
export const isValidObjectId = (id) => {
  if (!id || typeof id !== 'string') return false;
  // MongoDB ObjectId is either 12 bytes (24 hex characters) or can be a 12-byte string
  return /^[0-9a-fA-F]{24}$/.test(id);
};

// Utility function to safely get service ID
export const getServiceId = (service) => {
  if (!service) return null;
  
  // Try different possible ID fields
  const possibleIds = [service._id, service.id, service.serviceId];
  
  for (const id of possibleIds) {
    if (id && isValidObjectId(id)) {
      return id;
    }
  }
  
  console.warn('No valid ObjectId found in service:', service);
  return null;
};

// Utility function to determine if we should use company-specific endpoint
export const shouldUseCompanyEndpoint = (service) => {
  return service.companyId && isValidObjectId(service.companyId);
};

// Utility function to get the appropriate API endpoint for service operations
export const getServiceEndpoint = (service, operation = 'status') => {
  const serviceId = getServiceId(service);
  if (!serviceId) return null;
  
  const baseUrl = 'https://api.instacorp.ae/api/admin/data';
  
  if (shouldUseCompanyEndpoint(service)) {
    return `${baseUrl}/companies/${service.companyId}/services/${serviceId}/${operation}`;
  } else {
    return `${baseUrl}/services/${serviceId}/${operation}`;
  }
};